import React, { useState } from "react";
import { Button, Icon, Modal } from "semantic-ui-react";

const RequestAccessModal = ({ pop, yes, no, reqq }) => {
  return (
    <Modal open={pop} size="tiny" centered={false} onClose={no}>
      <Modal.Header>Request for Access</Modal.Header>

      <Modal.Content style={styles.content}>
        <span style={styles.uName}>{reqq}</span> is Requesting Access to the
        Unit.
        <p>Do you want to give the access?</p>
      </Modal.Content>

      <Modal.Actions>
        <Button primary onClick={yes}>
          YES
        </Button>
        <Button onClick={no}>NO</Button>
      </Modal.Actions>
    </Modal>
  );
};

const styles = {
  content: {
    color: "black",
    fontSize: "15px",
  },
  uName: {
    color: "red",
    fontWeight: "bold",
  },
};

export default RequestAccessModal;
